// Campaign invite links: applypa.com/?invite=threads-oct (on any page).
// The code is saved in the browser when someone lands, so it survives moving
// around the site and the Google sign-in redirect, and is sent right after signup.
// An unknown or switched-off code is ignored by the server.

const STORAGE_KEY = 'applypa_invite'
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000 // people may sign up days after the post

const read = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null')
    if (!saved?.code || Date.now() - saved.savedAt > MAX_AGE_MS) return null
    return saved.code
  } catch {
    return null
  }
}

/** Save `?invite=` from a route query (or the current URL). The newest link wins. */
export function captureInviteCode(query) {
  let code = query?.invite
  if (Array.isArray(code)) code = code[0]
  if (code == null && typeof window !== 'undefined') {
    code = new URLSearchParams(window.location.search).get('invite')
  }
  code = String(code || '').trim()
  if (!code || code.length > 60) return
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ code, savedAt: Date.now() }))
  } catch {
    /* storage blocked: the link just won't apply */
  }
}

export function getInviteCode() {
  return read()
}

export function clearInviteCode() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}

/**
 * After a Google sign-in, apply the saved code (if any). Never throws.
 * The server only applies it to accounts created in the last hour, so a
 * returning user who logs in through a campaign link is unaffected.
 */
export async function redeemInviteCode(apiClient) {
  const code = read()
  if (!code) return false
  try {
    const { data } = await apiClient.post('/auth/invite/redeem/', { code })
    clearInviteCode()
    return !!data?.applied
  } catch {
    return false // keep the code; a later sign-in can still use it
  }
}
